import * as React from 'react'

import { LOCIZE_NAMESPACE } from 'main/common'
import { Button, Title } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { i18nKeyPrefix } from '../../../i18n'
import { ScheduleTourModal_school } from '../../common/gql'
import { Container, TitleContainer } from './CancelConfirmation.styles'

const PRE = `${i18nKeyPrefix}-SCHEDULE-MODAL-CANCEL-CONFIRMATION`

interface IProps {
  school: ScheduleTourModal_school
  onComplete: () => void
}

export default function CancelConfirmation(props: IProps) {
  const { school, onComplete } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)
  const schoolName = school.name

  return (
    <Container>
      <TitleContainer>
        <Title kind="section">{t(`${PRE}-TITLE`, { schoolName })}</Title>
      </TitleContainer>
      <Button full onClick={onComplete}>
        {t(`${PRE}-DONE`)}
      </Button>
    </Container>
  )
}
